
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 6C4.11929 6 3 7.11929 3 8.5C3 9.88071 4.11929 11 5.5 11H7.17071C7.58254 9.83481 8.69378 9 10 9H14C15.3062 9 16.4175 9.83481 16.8293 11H18.5C20.9853 11 23 13.0147 23 15.5C23 17.9853 20.9853 20 18.5 20H14V18H18.5C19.8807 18 21 16.8807 21 15.5C21 14.1193 19.8807 13 18.5 13H16.8293C16.4175 14.1652 15.3062 15 14 15H10C8.69378 15 7.58254 14.1652 7.17071 13H5.5C3.01472 13 1 10.9853 1 8.5C1 6.01472 3.01472 4 5.5 4H10V6H5.5ZM10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H10Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowCallConnectorFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
